import { Button, Card, Flex, Stack, Text, Title } from "@mantine/core";
import style from "./pricing.module.css";

import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";

import { useTranslation } from "react-i18next";
import { FlexFeatures } from "../../../../molecules/pricing-features/flex-features";
import { ProfessionalFeatures } from "../../../../molecules/pricing-features/professional-features";
import { SchoolFeatures } from "../../../../molecules/pricing-features/schools-features";
import { useNavigate } from "react-router-dom";
import Navbar from "../navbar/navbar";
import { ContactUsSegment } from "../contact-us/contact-us";
import ScrollToTop from "../../../../molecules/scrollToTop/scrollToTop";
import { freeTrialWithoutPaymentCardEnabled } from "../../../../App";

export const PricingSegment = () => {
    const { t } = useTranslation(["common"]);
    const navigate = useNavigate();

    const isMobile = window.innerWidth.valueOf() < 768;

    const [ref, inView] = useInView({
        threshold: 0.4,
        triggerOnce: true,
    });

    const flexAnimation = useSpring({
        opacity: inView || isMobile ? 1 : 0,
        transform: inView || isMobile ? "scale(1)" : "scale(0.95)",
        from: { opacity: 0, transform: "scale(0.95)" },
        config: { mass: 1, tension: 380, friction: 60 },
        delay: 100,
    });

    const proAnimation = useSpring({
        opacity: inView || isMobile ? 1 : 0,
        transform: inView || isMobile ? "scale(1)" : "scale(0.95)",
        from: { opacity: 0, transform: "scale(0.95)" },
        config: { mass: 1, tension: 380, friction: 60 },
        delay: 0,
    });

    const schoolAnimation = useSpring({
        opacity: inView || isMobile ? 1 : 0,
        transform: inView || isMobile ? "scale(1)" : "scale(0.95)",
        from: { opacity: 0, transform: "scale(0.95)" },
        config: { mass: 1, tension: 380, friction: 60 },
        delay: 100,
    });

    return (
        <div className={style.wrapper} id="pricing">
            <div className={style.innerWrapper} ref={ref}>
                <Stack w={"100%"} justify={"center"}>
                    <h2 className={style.header}>{t('navbar.pricing')}</h2>
                    <br />

                    <div className={style.grid}>
                        <animated.div style={flexAnimation}>
                            <Card className={style.gridItem}>
                                <Card.Section px={"2rem"} pt={"1.5rem"} pb={"2rem"}>
                                    <div className={style.gridItemTopContent}>
                                        <p className={style.cardHeader}>{t("upgrade.flex.name")}</p>
                                        <div className={style.limitBox}>
                                            <p className={style.wordLimit}>{t("upgrade.flex.word-limit")}</p>
                                            <p className={style.scanEstimate}>{t("upgrade.flex.scan-estimate")}</p>
                                        </div>
                                        <FlexFeatures />
                                    </div>

                                    <br />
                                    <Text fz={"1.3rem"} fw={"500"}>
                                        {t("upgrade.flex.price")}
                                    </Text>
                                    <Text fz={14} fw={"500"} color="rgb(80, 80, 80)">
                                        {t("upgrade.flex.billing-frequency")}
                                    </Text>

                                    <Button
                                        className={"plausible-event-name=trial-flex"}
                                        variant="outline"
                                        color={"dark"}
                                        miw={"100%"}
                                        mt={"1rem"}
                                        onClick={() => navigate("/sign-up")}
                                    >
                                        {freeTrialWithoutPaymentCardEnabled ? t("upgrade.start-trial") : t("upgrade.start-7-day-trial")}
                                    </Button>
                                </Card.Section>
                            </Card>
                        </animated.div>

                        <animated.div style={proAnimation}>
                            <Card shadow="md" className={style.gridItemHighlighted}>
                                <Card.Section bg={"dark"} py={"0.25rem"} h={"2rem"}>
                                    <Flex justify={"center"} align={"center"}>
                                        <Title fw={500} fz={"1rem"} c={"white"} mt={"0.25rem"}>
                                            {t("upgrade.most-popular")}
                                        </Title>
                                    </Flex>
                                </Card.Section>

                                <Card.Section px={"2rem"} pt={"1.5rem"} pb={"2rem"}>
                                    <div className={style.gridItemTopContent}>
                                        <p className={style.cardHeader}>{t("upgrade.pro.name")}</p>
                                        <div className={style.limitBox}>
                                            <p className={style.wordLimit}>{t("upgrade.pro.word-limit")}</p>
                                            <p className={style.scanEstimate}>{t("upgrade.pro.scan-estimate")}</p>
                                        </div>
                                        <ProfessionalFeatures />
                                    </div>

                                    <br />
                                    <Flex columnGap={"0.5rem"} align={"baseline"}>
                                        <Text fz={"1.3rem"} fw={"500"}>
                                            {t("upgrade.pro.price")}
                                        </Text>
                                    </Flex>
                                    <Text fz={14} fw={"500"} color="rgb(80, 80, 80)">
                                        {t("upgrade.pro.billing-frequency")}
                                    </Text>

                                    <Button
                                        className={"plausible-event-name=trial-full-package"}
                                        color={"dark"}
                                        miw={"100%"}
                                        mt={"1rem"}
                                        onClick={() => navigate("/sign-up")}
                                    >
                                        {freeTrialWithoutPaymentCardEnabled ? t("upgrade.start-trial") : t("upgrade.start-7-day-trial")}
                                    </Button>
                                </Card.Section>
                            </Card>
                        </animated.div>

                        {/* <animated.div style={schoolAnimation}>
                            <Card shadow="md" className={style.gridItem}>
                                <Card.Section px={"2rem"} pt={"1.5rem"} pb={"2rem"}>
                                    <div className={style.gridItemTopContent}>
                                        <p className={style.cardHeader}>{t("upgrade.super.name")}</p>
                                        <div className={style.limitBox}>
                                            <p className={style.wordLimit}>{t("upgrade.super.word-limit")}</p>
                                            <p className={style.scanEstimate}>{t("upgrade.super.scan-estimate")}</p>
                                        </div>
                                        <SuperFeatures />
                                    </div>
                                    <br />
                                    <Text fz={"1.3rem"} fw={"500"}>
                                        {t("upgrade.super.price")}
                                    </Text>
                                    <Text fz={14} fw={"500"} color="rgb(80, 80, 80)">
                                        {t("upgrade.super.billing-frequency")}
                                    </Text>

                                    <Button
                                        className={"plausible-event-name=trial-super"}
                                        variant="outline"
                                        color={"dark"}
                                        miw={"100%"}
                                        mt={"1rem"}
                                        onClick={() => navigate("/sign-up")}
                                    >
                                        {t("upgrade.buy-now")}
                                    </Button>
                                </Card.Section>
                            </Card>
                        </animated.div> */}

                        <animated.div style={schoolAnimation}>
                            <Card shadow="md" className={style.gridItem}>
                                <Card.Section px={"2rem"} pt={"1.5rem"} pb={"2rem"}>
                                    <div className={style.gridItemTopContent}>
                                        <p className={style.cardHeader}>{t("upgrade.schools.name")}</p>
                                        <SchoolFeatures />
                                    </div>
                                    <br />
                                    <Text fz={"1.25rem"} fw={"500"}>
                                        {t("upgrade.schools.price")}
                                    </Text>
                                    <Text fz={14} fw={"500"} color="rgb(80, 80, 80)">
                                        {t("upgrade.schools.billing-frequency")}
                                    </Text>

                                    <Button
                                        className={"plausible-event-name=trial-schools"}
                                        variant="outline"
                                        color={"dark"}
                                        miw={"100%"}
                                        mt={"1rem"}
                                        onClick={() => navigate("/sign-up")}
                                    >
                                        {t("upgrade.schools.action-button")}
                                    </Button>
                                </Card.Section>
                            </Card>
                        </animated.div>
                    </div>
                </Stack>
            </div>
        </div>
    );
};

export const PricingPage = () => {
    return (
        <>
            <ScrollToTop />
            <Navbar />
            <div className={style.page}>
                <PricingSegment />
            </div>
            <ContactUsSegment />
        </>
    );
};
